import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (max-width: ", "px) {\n    border: none;\n    background: none;\n    box-shadow: none;\n\n    &:hover {\n      background: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from '../utils/styling/styled-components';
import { ActionButton } from '../ActionButton';
export var ActionStripButton = styled(ActionButton)(_templateObject(), function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.colors.white;
});